import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    request: {
        activeRowIndex: -1,
        visible: false,
        provider: "",
        TransactionID: null,
        payrollRef: null,
        method: null
    },
    response: {
        icon: "",
        transactionDetails: {},
        loading: false,
    },
    error: null,
};

const transactionDetailsSlice = createSlice({
    name: "transactionDetails",
    initialState,
    reducers: {
        setRequestData: (state, action) => {
            const {field, value} = action.payload;
            state.request[field] = value;
        },
        setResponseData: (state, action) => {
            const {field, value} = action.payload;
            state.response[field] = value;
        },
        resetRequest: (state) => {
            state.request = initialState.request;
        },
        resetResponse: (state) => {
            state.response = initialState.response;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const {
    setRequestData, setResponseData, resetRequest, resetResponse, setError
} = transactionDetailsSlice.actions;

export default transactionDetailsSlice.reducer;
